// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"331":"86a554cd","409":"2b3635fa","895":"9e046b4d"}[chunkId] + ".chunk.js";
};